import { formatDateTime } from '@pickleballinc/lib/format-dates';

import { TournamentEventMatch } from '@/modules/rankings/ppr/types';

interface PWRMatchInfoProps {
  match: TournamentEventMatch;
}

export const PWRMatchInfo = ({ match }: PWRMatchInfoProps) => {
  return (
    <div className='flex w-full flex-row items-center justify-between border-gray-200 border-b px-3 py-2 sm:h-[128px] sm:w-[160px] sm:flex-col sm:items-start sm:justify-center sm:border-none sm:py-0'>
      <p className='text-sm text-gray-800 font-medium sm:mb-2'>{match.roundTitle}</p>
      <div className='flex h-full flex-row items-center sm:h-auto sm:flex-col sm:items-start'>
        <p className='self-start font-medium text-sm text-gray-800 sm:mb-1 sm:mr-0'>
          {formatDateTime(match.matchStartDate)}
        </p>
      </div>
    </div>
  );
};
